export default "__VITE_ASSET__wHFksLIo__"